import { defineMessages } from "./define";

export const legalMessages = defineMessages({
  ru: {
    "legal.wallet": "Условия кошелька и пополнения",
  },
  en: {
    "legal.wallet": "Wallet & Onramp Terms",
  },
  ua: {
    "legal.wallet": "Умови гаманця та поповнення",
  },
  bl: {
    "legal.wallet": "Умовы кашалька і папаўнення",
  },
  de: {
    "legal.wallet": "Wallet- und Onramp-Bedingungen",
  },
  fr: {
    "legal.wallet": "Conditions du portefeuille et de conversion",
  },
  cn: {
    "legal.wallet": "钱包与入金条款",
  }
});
